/************************************************
 * This file enables us to make UI changes before
 * the client is loaded.
 * This loads before Nuxt
*************************************************/
import { GET_MYSITE } from '@/queries';
import { hexToHSL } from '@/lib/hexToHSL';
import { bootTheme } from '@/lib/bootTheme';

export default defineNuxtPlugin(async (_nuxtApp) => {
  const config = useRuntimeConfig();
  const creditPacks = await getCreditPacks() || [];
  const parkingPacks = await getParkingPacks() || [];

  if (import.meta.client && !config?.public?.isMain) {
    globalConfig().setPacks([ ...parkingPacks ]);

    try {
      const { data } = await useGraphQL(GET_MYSITE);
      const theme = JSON.parse(data?.value?.data?.mysite?.config).site?.theme;
      globalConfig().setGlobalConfig(JSON.parse(data?.value?.data?.mysite?.config));
      // Set the CSS variable that Tailwind is actually using
      if (!config?.public?.isMain) {
        bootTheme(theme)
      }
    } catch (error) {
      console.error('Failed to convert hex to HSL:', error);
    }
  } else {
    document.documentElement.style.setProperty('--nav-link', hexToHSL("#FFBD59"));
    globalConfig().setPacks([...(creditPacks || []), ...(parkingPacks || [])]);
  }

  // TODO: NOT HERE -- retrieve logo from window
  // THIS ACTUALLY MIGHT BE BETTER FOR LOCALSTORAGE INSTEAD OF THE WINDOW
  config?.public?.isMain
    ? window.__ss_config = { isMain: config?.public?.isMain }
    : window.__ss_config = {
      name: globalConfig()?.siteName, 
      plan: globalConfig()?.ownerPlan?.name,
      isMain: config?.public?.isMain
    };
});
